// 此文件由 DemoRoutesPlugin 自动生成，请勿手动修改
// Demo 模式在生产环境已禁用

export const demoRoutes: any[] = [];
export const isDemoMode = false;
